// removed by extract-text-webpack-plugin
module.exports = {"panel":"_1AhhfUmTdEbIECjTnx73cc","thumb":"_3eumtQcF7iwEY5M6SaKyH8","descr":"_2TEXCttXk9mtppGggh4VHC","header":"cpzZDIfNSBz-sQpKvaRuV"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/NewProject/NewProject.scss
// module id = 1358
// module chunks = 1